import { AlertOctagon, Mail } from 'lucide-react'

/**
 * AF-128 — banner rendered next to the Lift button when the block is
 * regulatory and the current user lacks `blocks:lift_regulatory`. Per AC:
 * "regulatory blocks show warning 'legal team must lift — contact compliance'".
 */
export function RegulatoryWarning() {
  return (
    <div
      role="note"
      className="flex items-start gap-2 rounded-md border border-priority-critical/30 bg-priority-critical/5 px-3 py-2 text-sm"
    >
      <AlertOctagon
        size={14}
        className="mt-0.5 shrink-0 text-priority-critical"
        aria-hidden
      />
      <div className="flex flex-col gap-0.5">
        <p className="font-medium text-priority-critical">
          Legal team must lift this block.
        </p>
        <p className="text-xs text-muted-fg">
          Regulatory blocks (NFIU, court orders) require the
          <span className="mx-1 rounded-sm bg-muted px-1 font-mono text-[0.625rem]">
            blocks:lift_regulatory
          </span>
          permission. Contact compliance to escalate.
        </p>
        <a
          href="mailto:compliance@example.com?subject=Block%20lift%20request"
          className="mt-1 inline-flex items-center gap-1 text-xs text-primary hover:underline"
        >
          <Mail size={10} aria-hidden /> Email compliance
        </a>
      </div>
    </div>
  )
}
